import React from 'react'

import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import NavigationMenuItem from "../../../../../layout/menu/menu-items/menu-item"
import {SelectParent_SectionType} from "../../@const"
import Search from "../../../../gd-components/popover-menu/search/search"
import SelectParent_Popover from "./popover"
import {SpaceProto} from "../../../../model2/space/space-proto"
import {selectParent_getProjects} from "../../actions/get-projects"
import ProjectSession from "../../../../model2/project/project-session"
import {ItemDisplay} from "../../../../model2/item/item-model"

type Props = {
    parent: SelectParent_Popover
}

// const debug = "SelectParent_Spaces"
const debug = false

export default function SelectParent_Spaces(props: Props) {

    const parent = props.parent

    return (
        <div className="left-content flex-column-left-top w-200 h-100-percent">

            <Search searchString        = {parent.state.searchString}
                    showDeleteButton    = {true}
                    onSearch            = {parent.onSearchChange}
                    onEscapePressed     = {parent.hidePopover}/>

            {parent.state.searchString.length === 0 && (
                <VScroll className="h-100-percent p-b-10">
                    <div className="ui5-menu p-t-0">
                        <div className="menu-section">

                            {!!parent.props.parentSelector.props.unselectLabel &&
                                <NavigationMenuItem className   = "p-l-10"
                                                    name        = {parent.props.parentSelector.props.unselectLabel}
                                                    selected    = {!parent.state.currentSection}
                                                    icon        = {parent.props.parentSelector.props.unselectIcon}
                                                    onClick     = {() => {
                                                        parent.onSelectWorkspace()
                                                        parent.props.onParentSelected(null)
                                                    }}/>}

                            {_.map(parent.spacesToShow, (space:SpaceProto)=>{
                                return (
                                    <NavigationMenuItem key          = {space.id}
                                                        className    = "p-l-10"
                                                        name         = {space.title}
                                                        // @ts-ignore
                                                        selected     = {parent.state.currentSection?.id === space.id}
                                                        icon         = {space.icon}
                                                        onClick      = {() => {parent.onSelectWorkspace(space)}}/>
                                )
                            })}

                            {(parent.showStarred || parent.showPinned) &&
                                <>
                                    <div className="separator-h"/>

                                    {parent.showStarred &&
                                        <NavigationMenuItem className="p-l-10"
                                                            name="Starred Projects"
                                                            selected={parent.state.currentSection === SelectParent_SectionType.STARRED}
                                                            icon="i5-star-empty ui5-color-yellow"
                                                            onClick={() => {
                                                                parent.onSelectSection(SelectParent_SectionType.STARRED)
                                                            }}/>}

                                    {parent.showPinned &&
                                        <NavigationMenuItem className="p-l-10"
                                                            name="Pinned Projects"
                                                            selected={parent.state.currentSection === SelectParent_SectionType.PINNED}
                                                            icon="i5-pin"
                                                            onClick={() => {
                                                                parent.onSelectSection(SelectParent_SectionType.PINNED)
                                                            }}/>}
                                </>}
                        </div>
                    </div>
                </VScroll>
            )}
        </div>
    )
}
